import { createSvgComponent } from "../../icon/createSvgComponent";
import Modalclose from "@core/__generated__/icon/figma/modalclose.svg";
export default createSvgComponent(Modalclose);